import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  Subject,
  Observable,
  of,
  interval,
  map,
  startWith,
  takeWhile,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  filter,
  tap,
} from 'rxjs';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';
import * as fromDashboardActions from 'src/app/state-management/actions/dashboard.action';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { userList } from 'src/app/models/selectMenu';
import { WebcamImage } from 'ngx-webcam';
import * as moment from 'moment';
import { Visitor } from 'src/app/models/visitor';
import html2canvas from 'html2canvas';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { ScreenType } from 'src/app/enums/ScreenType';
import { LoadingSpinnerDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/loading-spinner-dialog/loading-spinner-dialog.component';
import { PreApprovedVisitorTimeService } from 'src/app/services/preApprovedVisitors/pre-approved-visitor-time.service';
import { PreApprovedVisitorDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/pre-approved-visitor-dialog/pre-approved-visitor-dialog.component';
import { UserRegDetails } from 'src/app/models/user';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { HostApprovalComponent } from 'src/app/modules/security-pass/components/host-approval/host-approval.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/app/environments/environments';
import {
  EncryptionService,
  UserDetailsToken,
} from 'src/app/services/Encryption/encryption.service';
@Component({
  selector: 'app-visitor-dashboard',
  templateUrl: './visitor-dashboard.component.html',
  styleUrls: ['./visitor-dashboard.component.scss'],
})
export class VisitorDashboardComponent
  implements OnInit, AfterViewInit, AfterContentChecked
{
  @Input() set dashboardData(val: IDashboardState) {
    if (val) this.setDashboardData(val);
  }
  @Input() set isNotRegularFlow(val: boolean) {
    this.isCloseDisplay = val;
  }
  private trigger: Subject<any> = new Subject();
  public webcamImage!: WebcamImage;
  private nextWebcam: Subject<any> = new Subject();
  sysImage = '';
  hostName = '';
  isCloseDisplay = false;
  isEntryCleared = false;
  showWaitingSection = false;
  categoryChartData: any;
  timeNow = Date.now();
  visitorData: IDashboardState;
  usersList: userList[] = [];
  showWebcam = false;
  isTimerFinished = false;
  display: any;
  file: any;
  isNotifyHost = false;
  isShowVisitorDetail = false;
  visitorDetails: Visitor;
  deviceSelected = '';
  availableDevices: any = [];
  isDeviceSelected = false;
  qrCodeData = '';
  isShowPendingApproval = false;
  expandedDetail = '';
  expandedVisitorDetails: Visitor;
  isManualVehicle = false;
  isShowVisitorTimline = false;
  isLoggedInUser = false;
  OrgId: string = null;
  orgName: string = null;
  orgAddress: string = null;
  orgEmail: string = null;
  printerAllowed = environment.printerAllowed;
  displayedColumns = [
    'no',
    'visname',
    'hostname',
    'date',
    'time',
    'purpose',
    'security',
    'Details',
  ];
  NumberList = [
    'UP32KW8888',
    'UP32MS9777',
    'UP32EW1245',
    'UP32QA7172',
    'UP32KW1111',
    'UP32KW2343',
  ];
  @ViewChild('QrCode', { static: false }) QrCode: ElementRef;
  @ViewChild('ClearEntryDialog', { static: true })
  clearEntryDialog: TemplateRef<any>;
  @ViewChild('phoneInput', { read: ElementRef, static: false })
  phoneInputRef: ElementRef;
  @ViewChild('RefreshingVisitor', { static: true })
  refreshingVisitor: TemplateRef<any>;

  @ViewChild('PrivacyPolicyVisitor', { static: true })
  privacyPolicyVisitor: TemplateRef<any>;

  privacyPolicyAccepted: boolean = false;

  screenSize: ScreenType;
  visID = '';
  hostFilter = new FormControl();
  filteredHosts: UserRegDetails[] = [];
  visitorList: Visitor[];
  filteredVisitor: Observable<Visitor[]>;
  visitorCtrl = new FormControl('');
  isChecked = false;
  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
    visitorName: new FormControl<String | null>(null),
  });
  currentDate: Date = new Date();
  baseServerURL = environment.apiUrl;
  loggedUser: UserDetailsToken;

  constructor(
    private store: Store<IAumyeState>,
    private formbuilder: FormBuilder,
    private cdref: ChangeDetectorRef,
    private dialog: MatDialog,
    private screen: AumyeResponsiveScreenService,
    private visitorTime: PreApprovedVisitorTimeService,
    private httpclient: HttpClient,
    private encryptionService: EncryptionService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  private _filterStates(value: string): Visitor[] {
    const filterValue = value.toLowerCase();
    return this.visitorList.filter((visitor) =>
      visitor.firstName.toLowerCase().includes(filterValue)
    );
  }
  isEnable = false;
  isUniqueVisitor = true;
  isValid = true;
  visitors: Visitor[] = [];
  isDisabled = true;
  private phoneInputSubscription: Subscription | null = null;
  resetFields(): void {
    this.visitorGateEntryPass.reset();
    this.isDisabled = true;
    this.isEnable = false;
    this.visitorGateEntryPass.controls.isReVisit.setValue(false);
    this.showWebcam = false;
    const formArray = this.visitorGateEntryPass.get(
      'selectedHosts'
    ) as FormArray;
    this.sysImage = '';
    this.usersTemp = [];
    formArray.clear();
    this.visitorGateEntryPass.disable();
  }
  ngOnInit() {
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.isLoggedInUser = this.loggedUser.role.toLowerCase() === 'user';
    this.OrgId = this.loggedUser.organizationID;
    this.orgName = this.loggedUser.organizationName;
    this.orgAddress = this.loggedUser.organizationAddress;
    this.orgEmail = this.loggedUser.organizationEmail;

    if (!navigator.mediaDevices?.enumerateDevices) {
      console.log('enumerateDevices() not supported.');
    } else {
      (async () => {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true,
        });
        await navigator.mediaDevices
          .enumerateDevices()
          .then((devices) => {
            devices.forEach((device) => {
              if (device && device.kind === 'videoinput') {
                this.availableDevices.push(device);
              }
            });
          })
          .catch((err) => {
            console.error(`${err.name}: ${err.message}`);
          });
        stream.getTracks().forEach((track) => track.stop());
      })();
    }
    if (this.phoneInputSubscription) {
      this.phoneInputSubscription.unsubscribe();
    }
    this.isDisabled = true;
    this.phoneInputSubscription = this.phoneForm
      .get('phone')
      ?.valueChanges.pipe(
        debounceTime(500), // Wait 500ms for user input to stabilize
        distinctUntilChanged(), // Prevent duplicate calls for the same input
        filter(() => this.phoneForm.get('phone')?.valid), // Only valid inputs proceed
        tap(() => {
          if (!this.phoneForm.get('phone')?.valid) {
            this.resetFields();
          }
        }), // Reset fields before making API call
        tap((phoneNumber) => {
          this.checkPhoneNumber(phoneNumber);
        }) // Call the void function
      )
      .subscribe();
    this.phoneForm.get('phone')?.valueChanges.subscribe((value) => {
      if (!this.phoneForm.get('phone')?.valid) {
        this.resetFields();
      }
    });
    this.visitorGateEntryPass.disable();
    this.getDashboardStatistics();

    this.filteredHosts = this.visitorData.orgUserList.filter(
      (x) => x.userRole != 'kiosk'
    );
    this.hostFilter.valueChanges.subscribe((value) => {
      this.filteredHosts = this.filterHosts(value);
    });
    this.selectedUsersControl.valueChanges.subscribe((value) => {
      this.filteredHosts = this.filterHosts(value);
    });
    this.visitorCtrl.valueChanges.subscribe((x) => {
      if (this.isVisitorSelect) {
        this.visitorGateEntryPass.reset();
        const formArray = this.visitorGateEntryPass.get(
          'selectedHosts'
        ) as FormArray;
        this.usersTemp = [];
        formArray.clear();
        const inputElement =
          this.phoneInputRef.nativeElement.querySelector('input');
        if (inputElement) {
          inputElement.value = ''; // Clear the actual input element
        }
        this.isVisitorSelect = false;
      }
    });
    this.filteredVisitor = this.visitorCtrl.valueChanges.pipe(
      startWith(''),
      map((visitor) =>
        visitor ? this._filterStates(visitor) : this.visitorList.slice()
      )
    );

    /* this.visitorGateEntryPass
      .get('phoneNumber')
      ?.valueChanges.subscribe((value) => {
        if (this.visitorGateEntryPass.get('phoneNumber')?.valid) {
          if (this.visitors.length == 0) this.checkPhoneNumber(value);
        } else {
          this.isUniqueVisitor = true;
        }
      }); */
  }
  ngOnDestroy(): void {
    if (this.phoneInputSubscription) {
      this.phoneInputSubscription.unsubscribe();
    }
  }
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });
  visitorGateEntryPass = this.formbuilder.group({
    visitorId: [''],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.email]],
    phoneNumber: ['', Validators.required],
    visitorAddress: ['', Validators.required],
    purpose: ['', Validators.required],
    carRegistration: [],
    hostUserId: [''],
    selectedHosts: this.formbuilder.array([], Validators.required),
    hostEmail: [''],
    hostName: [''],
    department: [''],
    profilePicture: ['', Validators.required],
    visitDateTime: [new Date().toISOString()],
    gender: [''],
    visitorCategory: ['', Validators.required],
    isPreApproved: [false],
    isReVisit: [false, Validators.required],
    visitorTimline: [''],
    sendQR: [false],
    privacyPolicyAccepted: [false, Validators.required],
  });
  visitorGuardConfirm = this.formbuilder.group({
    guardName: [localStorage.getItem('FullName'), Validators.required],
    checkIn: [moment().format('MMMM Do YYYY, hh:mm a'), Validators.required],
  });
  isSearchInvalid(): boolean {
    const visitorName = this.range.controls['visitorName'].value;
    const start = this.range.controls['start'].value;
    const end = this.range.controls['end'].value;

    // Validate the form fields: visitorName, start, and end dates
    return !visitorName || !(start && end); // If any condition is met, return true (form is invalid)
  }
  setDashboardData(val: IDashboardState) {
    this.visitorData = val;
    this.visitorList = this.visitorData.visitorDetails.visitorList;
    this.visitorList = this.visitorList.filter((x) => x.checkOut != null);
    if (this.visitorDetails) {
      let newVisitorDetails = this.visitorData.visitorDetails.visitorList.find(
        (x) => x.visitorID == this.visitorDetails.visitorID
      );
      this.visitorDetails = newVisitorDetails;
    }
    this.getDashboardStatistics();
  }
  statisticsData: statisticsData = null;
  getDashboardStatistics() {
    const todaysVisitors = this.visitorData.visitorDetails.visitorList;
    this.statisticsData = {
      singleTotal: todaysVisitors.length,
      singleUnverified: todaysVisitors.filter((x) => x.securityStatus == 0)
        .length,
      singleVerified: todaysVisitors.filter((x) => x.securityStatus == 1)
        .length,
      singleAutoRejected: todaysVisitors.filter((x) => x.securityStatus == 3)
        .length,
      singleRejected: todaysVisitors.filter((x) => x.securityStatus == -1)
        .length,
      singlePending: todaysVisitors.filter(
        (x) => x.securityStatus == 0 && x.visitorType == '2'
      ).length,
      preApprovedCount: todaysVisitors.filter((x) => x.visitorType == '1')
        .length,
      gateEntryCount: todaysVisitors.filter((x) => x.visitorType == '2').length,
      preVerifiedCount: todaysVisitors.filter((x) => x.visitorType == '3')
        .length,
      rapidVisitorCount: todaysVisitors.filter((x) => x.visitorType == '0')
        .length,
    };
  }
  updateFormControlValue(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.visitorGateEntryPass.controls.firstName.setValue(value);
  }
  isVisitorSelect = false;
  // visitorSelect(val: any, isMobile: boolean = false) {
  visitorSelect(val: Visitor[]) {
    const visitor: Visitor[] = val;
    const formArray = this.visitorGateEntryPass.get(
      'selectedHosts'
    ) as FormArray;
    this.usersTemp = [];
    formArray.clear();
    this.visitorGateEntryPass.controls.firstName.setValue(visitor[0].firstName);
    this.visitorGateEntryPass.controls.lastName.setValue(visitor[0].lastName);
    this.visitorGateEntryPass.controls.email.setValue(visitor[0].email);
    this.visitorGateEntryPass.controls.phoneNumber.setValue(
      visitor[0].phoneNumber
    );
    this.visitorGateEntryPass.controls.visitorAddress.setValue(
      visitor[0].visitorAddress
    );
    this.visitorGateEntryPass.controls.isReVisit.setValue(true);
    this.visitorGateEntryPass.controls.visitorId.setValue(visitor[0].visitorID);
    this.visitorGateEntryPass.controls.visitorTimline.setValue(
      visitor[0].visitorTimline
    );
    this.isVisitorSelect = true;
  }
  onClose() {
    this.store.dispatch(new fromDashboardActions.InitDashboard({}));
  }
  check() {
    this.dashboardData.visitorDetails.totalVerified;
  }
  onInitVisitorGateEntry() {
    this.store.dispatch(new fromDashboardActions.InitVisitorGateEntry({}));
  }
  onShowVisitorDetail(val: any) {
    this.isShowVisitorDetail = false;
    this.visitorDetails = null;
    this.visitorDetails = val;
    this.isShowVisitorDetail = true;
    this.isShowVisitorTimline = false;
    setTimeout(() => {
      const targetElement = document.querySelector(
        '.scroll-to-visitor-details'
      );
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 250);
  }
  onCloseVisitorDetail() {
    this.isShowVisitorDetail = false;
  }
  getSnapshot(): void {
    this.trigger.next(void 0);
    this.showWebcam = !this.showWebcam;
  }
  captureImg(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.sysImage = webcamImage!.imageAsDataUrl;
    this.visitorGateEntryPass.controls.profilePicture.setValue(this.sysImage);
  }
  get invokeObservable(): Observable<any> {
    return this.trigger.asObservable();
  }
  get nextWebcamObservable(): Observable<any> {
    return this.nextWebcam.asObservable();
  }
  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
    this.showWebcam = true;
  }
  onDeviceSelectChange(val: any) {
    this.isDeviceSelected = true;
    this.showNextWebcam(val);
  }
  notifyHost() {
    const data: any = this.visitorGateEntryPass.value;
    const filteredVisitors: Visitor[] = this.visitorList.filter(
      (x) => x.visitorID == data.visitorId
    );
    data['visitorDetails'] = filteredVisitors;
    this.store.dispatch(new fromDashboardActions.VisitorNotifyHost(data));
    this.onReset();
    this.filteredHosts = this.visitorData.orgUserList;
    this.visitorGateEntryPass.controls.isReVisit.setValue(false);
    this.visitorGateEntryPass.controls.isPreApproved.setValue(false);
    this.visitorGateEntryPass.controls.sendQR.setValue(false);
    this.isChecked = false;
    this.usersTemp = [];
    const formArray = this.visitorGateEntryPass.get(
      'selectedHosts'
    ) as FormArray;
    formArray.clear();
    this.hostFilter.setValue('');
    if (this.visitorGateEntryPass.value.isReVisit) {
      const dialogRef = this.dialog.open(this.clearEntryDialog, {
        disableClose: true,
      });
    }
    // this.showWaitingSection = true;
    // this.timer(1);
  }
  timer(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;
    const prefix = minute < 10 ? '0' : '';
    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.isTimerFinished = true;
        this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
        clearInterval(timer);
        if (
          this.visitorData.gateEntryVisitor.visitorDetails.isHostVerified == '0'
        ) {
          this.buttonTimer(1);
        }
      }
    }, 1000);
  }
  buttonTimer(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;
    const prefix = minute < 10 ? '0' : '';
    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.store.dispatch(new fromDashboardActions.UpdateVisitorList({}));
        if (
          this.visitorData.visitorDetails.visitorList
            .filter((item) => item.isGateEntry == '1')
            .filter((item) => item.isHostVerified == '0')[0].isHostVerified ==
          '0'
        ) {
          this.buttonTimer(1);
        }
        clearInterval(timer);
      }
    }, 1000);
  }
  hostSelect(val: MatAutocompleteSelectedEvent) {
    this.visitorData.orgUserList.forEach((item) => {
      if (item.firstname + ' ' + item.lastname === val.option.value) {
        this.hostName = item.firstname + ' ' + item.lastname;
        this.visitorGateEntryPass.controls.hostEmail.setValue(item.email);
        this.visitorGateEntryPass.controls.hostUserId.setValue(item.userId);
      }
    });
    this.visitorGateEntryPass.controls.hostName.setValue(this.hostName);
  }
  checkStatus(val: any) {
    this.store.dispatch(new fromDashboardActions.HostStatus(val));
  }
  onClearGuardEntry() {
    this.isEntryCleared = true;
    let checkInDetails = {
      guardName: this.loggedUser.fullName,
      checkIn: new Date(),
      visitorId: this.visitorData.gateEntryVisitor.visitorId,
      visitorEmail: this.visitorGateEntryPass.controls.email.value,
      visitorHost: this.visitorGateEntryPass.controls.hostName.value,
      visitorName:
        this.visitorGateEntryPass.controls.firstName.value +
        ' ' +
        this.visitorGateEntryPass.controls.lastName.value,
      qrCode: this.qrCodeData,
    };
    this.store.dispatch(
      new fromDashboardActions.ClearVisitorEntry(checkInDetails)
    );
  }
  captureScreen() {
    var data = this.QrCode;
    const dialogRef = this.dialog.open(this.clearEntryDialog, {
      disableClose: true,
    });
    html2canvas(data.nativeElement).then((canvas) => {
      const contentDataURL = canvas.toDataURL('image/png');
      this.qrCodeData = contentDataURL;
      this.onClearGuardEntry();
    });
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  onReset() {
    this.isEnable = false;
    this.isUniqueVisitor = true;
    this.isValid = true;
    this.visitors = [];
    this.isDisabled = true;
    this.phoneForm.reset();
    this.visitorGateEntryPass.reset();
    this.sysImage = '';
    this.showWebcam = false;
    this.visitorCtrl.setValue(``);
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  onShowDetails(val: Visitor) {
    if (
      val.isHostVerified == '0' &&
      val.isPreApproved != 'true' &&
      val.securityStatus == 0
    ) {
      this.checkStatus(val.visitorID);
    } else if (val.securityStatus == 3) {
      if (this.screenSize == ScreenType.Mobile) {
        const dialogRef = this.dialog.open(HostApprovalComponent, {
          disableClose: true,
          data: val,
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
          } else {
            // window.location.reload();
          }
        });
      }
    } else if (val.isPreApproved == 'true') {
      this.visID = val.visitorID;
      const dialogRef = this.dialog.open(PreApprovedVisitorDialogComponent, {
        disableClose: true,
        width: '1080px',
        data: val,
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          const matchedUser = this.visitorData.orgUserList.find(
            (user) => user.userId.toLowerCase() === val.hostUserId.toLowerCase()
          );
          const filteredVisitors: Visitor[] = this.visitorList.filter(
            (x) => x.visitorID == result.visitorId
          );
          this.hostName = matchedUser.firstname + ' ' + matchedUser.lastname;
          result['hostEmail'] = matchedUser.email;
          result['hostUserId'] = matchedUser.userId;
          result['visitorDetails'] = filteredVisitors;
          this.visitorGateEntryPass.controls.hostName.setValue(this.hostName);

          const item = {
            HostName:
              matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
            HostUserId: matchedUser.userId,
            HostEmail: matchedUser.email,
            HostPhone: matchedUser.phoneNumber,
          };
          result.selectedHosts = [item];
          this.store.dispatch(
            new fromDashboardActions.VisitorNotifyHost(result)
          );
          console.log(result, 'Check mmmmm');
          this.markAsArrived(val);
        }
        this.visID = '';
      });
    }
  }
  openPrivacyPolicy() {
    const dialogRef = this.dialog.open(this.privacyPolicyVisitor, {
      width: '600px',
      maxHeight: '80vh',
    });

    setTimeout(() => {
      const targetElement = document.querySelector('.policy-header');
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 250);
  }
  markAsArrived(visitor: Visitor): void {
    // this.visitorTime.startTimer(visitor);
  }
  getVisitorTimerObservable(visitor: Visitor): Observable<string> {
    return this.visitorTime.getMinutesAndSecondsRemaining(visitor);
  }
  getVisitorTimerMinutes(visitor: Visitor): Observable<number> {
    return this.visitorTime.getMinutesRemaining(visitor);
  }
  getOnlyPendingVisitors(val: Visitor[]) {
    return val.filter(
      (index) =>
        (index.isGateEntry == '1' || index.visitorType == '3') &&
        new Date().getDate() == new Date(index.visitDateTime + 'Z').getDate()
    );
  }
  onChangeSelected(val: MatSelectChange) {
    if (val.value === 'manual') {
      this.isManualVehicle = true;
      this.visitorGateEntryPass.controls.carRegistration.setValue('');
    }
  }
  onShowVisitorTimeline(val: any) {
    this.isShowVisitorTimline = val;
  }
  onUpdateVisitorDetails(val: any) {
    this.dialog.open(LoadingSpinnerDialogComponent, {
      disableClose: true,
    });
    val['NoStatus'] = true;
    this.store.dispatch(new fromDashboardActions.UpdateVisitorDetails(val));
    this.isShowVisitorDetail = false;
  }
  onMarkAsVisitor() {}

  hasVisitorTimer(visitorID: string) {
    const savedTimers = JSON.parse(
      localStorage.getItem('visitorTimers') || '{}'
    );
    if (savedTimers.hasOwnProperty(visitorID)) {
      return true;
    }
    return false;
  }
  filterHosts(value: string) {
    // Implement your filtering logic here
    const filterValue = value.toLowerCase();
    return this.visitorData.orgUserList.filter((host) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  getFormatedDate(val: any) {
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
  getExpectedCheckoutTimeNumber(row: any): Observable<number> {
    // Assuming row.checkIn is a valid Date object
    const expectedCheckoutTime = new Date(row.checkIn + 'Z');
    expectedCheckoutTime.setMinutes(expectedCheckoutTime.getMinutes() + 30);

    return interval(1000) // Emit a value every second
      .pipe(
        startWith(0), // Emit the initial value immediately
        map(() => {
          const currentTime = new Date();
          const timeDifferenceInMilliseconds =
            expectedCheckoutTime.getTime() - currentTime.getTime();
          const timeDifferenceInSeconds = Math.max(
            Math.floor(timeDifferenceInMilliseconds / 1000),
            0
          );

          const minutes = Math.floor(timeDifferenceInSeconds / 60);
          const seconds = timeDifferenceInSeconds % 60;
          return minutes + seconds / 100; // Display seconds as a decimal part of the minute
        }),
        takeWhile((time) => time > 0, true) // Stop emitting when time is less than 0
      );
  }
  getExpectedCheckoutTime(row: any): Observable<string> {
    // Assuming row.checkIn is a valid Date object
    const expectedCheckoutTime = new Date(row.checkIn + 'Z');
    expectedCheckoutTime.setMinutes(expectedCheckoutTime.getMinutes() + 30);

    const currentTime = new Date();
    const timeDifferenceInMilliseconds =
      expectedCheckoutTime.getTime() - currentTime.getTime();
    const timeDifferenceInSeconds = Math.max(
      Math.floor(timeDifferenceInMilliseconds / 1000),
      0
    );

    const minutes = Math.floor(timeDifferenceInSeconds / 60);
    const seconds = timeDifferenceInSeconds % 60;

    // Format minutes and seconds with leading zeros
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    // Display seconds as a decimal part of the minute
    const formattedTime = `${formattedMinutes}:${formattedSeconds}`;

    // Return "minute" or "minutes" based on the value of minutes
    const minuteLabel = minutes === 1 ? 'minute' : 'minutes';
    return of(`${formattedTime} ${minuteLabel}`);
  }
  onCheckboxChange() {
    if (this.isChecked) {
      this.visitorGateEntryPass.controls.sendQR.setValue(false);
      this.isChecked = false;
    } else {
      this.visitorGateEntryPass.controls.sendQR.setValue(true);
      this.isChecked = true;
    }
  }

  ngAfterViewInit(): void {
    this.cdref.detectChanges();
  }
  selectedUsersControl = new FormControl();
  usersTemp: string[] = [];
  addUser(event: any): void {
    const value = event.option.value;
    if (value && !this.usersTemp.includes(value)) {
      this.usersTemp.push(value);
      const matchedUser = this.visitorData.orgUserList.find(
        (user) =>
          (user.firstname + ' ' + user.lastname).toLowerCase() ===
          value.toLowerCase()
      );
      const item = {
        HostName:
          matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
        HostUserId: matchedUser.userId,
        HostEmail: matchedUser.email,
        HostPhone: matchedUser.phoneNumber,
      };
      this.selected.push(this.formbuilder.control(item));
    }
    setTimeout(() => {
      this.selectedUsersControl.setValue('');
    }, 250);
    event.option.deselect();
  }
  clearInputField(): void {
    this.selectedUsersControl.setValue(''); // Clear the input field value
  }
  removeUser(user: string): void {
    const index = this.usersTemp.indexOf(user);
    const formArray = this.visitorGateEntryPass.get(
      'selectedHosts'
    ) as FormArray;
    if (index >= 0) {
      this.usersTemp.splice(index, 1);
      formArray.removeAt(index);
    }
  }
  get selected() {
    return this.visitorGateEntryPass.get('selectedHosts') as FormArray;
  }
  getCustomPhoneNumber(val: string): string {
    if (val && val.length > 4) {
      // Extract the last 4 digits
      const last4Digits = val.slice(-4);
      // Mask the rest of the phone number
      const maskedPart = 'XXX-XXX-';
      return maskedPart + last4Digits;
    } else {
      // Return the original value if it's too short
      return val;
    }
  }
  onPostVisitorComment(val: any) {
    this.store.dispatch(new fromDashboardActions.PostUserComment(val));
  }
  checkPhoneNumber(phoneNumber: string): void {
    let baseServerURL = this.baseServerURL + 'CheckExistingVisitor';
    let auth_token = localStorage.getItem('AccessToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: auth_token,
      }),
    };
    this.httpclient
      .get(
        `${baseServerURL}?Number=${phoneNumber}&OrgId=${this.OrgId}&Type=2`,
        httpOptions
      )
      .subscribe(
        (response: any) => {
          this.visitorGateEntryPass.reset();
          if (response.exists) {
            if (response.isValid) {
              this.isUniqueVisitor = false;
              this.isValid = response.isValid;
              this.visitors = response.visitor;
              this.setInputField();
            } else {
              this.visitors = [];
              this.visitors = response.visitor;
              this.isUniqueVisitor = false;
              this.isValid = false;
            }
          } else {
            this.visitorGateEntryPass.enable();
            this.isUniqueVisitor = true;
            this.isDisabled = false;
            this.visitors = [];
            this.visitorGateEntryPass.controls.isReVisit.setValue(false);
            this.visitorGateEntryPass.controls.phoneNumber.setValue(
              this.phoneForm.value.phone
            );
          }
        },
        (error) => {
          console.error('Error checking phone number', error);
        }
      );
  }
  isManuallyCheck = false;
  onManualCheckVisitor() {
    let val: any = this.visitors[0];
    val['isManualCheckout'] = true;
    let baseServerURL = this.baseServerURL + 'UpdateVisitor';
    let auth_token = localStorage.getItem('AccessToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: auth_token,
      }),
    };
    this.httpclient
      .post(`${baseServerURL}`, val, {
        headers: httpOptions.headers,
        responseType: 'text',
      })
      .subscribe(
        (response: any) => {
          this.setInputField();
          this.isValid = true;
          this.isManuallyCheck = true;
          this.visitorGateEntryPass.disable();
          this.visitorGateEntryPass.controls.phoneNumber.setValue(
            this.phoneForm.value.phone
          );
        },
        (error) => {
          console.error('Error checking phone number', error);
        }
      );
  }
  searchedImage: string = null;
  setInputField() {
    this.searchedImage = this.visitors[0].profilePicture;
    this.visitorSelect(this.visitors);
  }
  isClickedSubmit = false;
  onGetRangeData() {
    this.dialog.open(this.refreshingVisitor, {
      disableClose: true,
    });
    const data = {
      startDate: this.range.controls.start.value,
      endDate: this.range.controls.end.value,
      visitorName: this.range.controls.visitorName.value,
    };
    this.store.dispatch(new fromDashboardActions.GetRangedVisitorData(data));
    this.isClickedSubmit = true;
  }
  onGetResetData() {
    this.range.reset();
    this.store.dispatch(new fromDashboardActions.GetVisitorTabData({}));
  }
  onChangeNumber(val: any) {
    this.visitorGateEntryPass.controls.phoneNumber.setValue(
      this.phoneForm.value.phone
    );
  }
  onEditDetails() {
    this.isDisabled = false;
    this.visitorGateEntryPass.enable();
  }
  ScreenType = ScreenType;
}
export class Program {
  public ProgramID: number;
  public Name: string;
  public children?: Program[];
}
export interface State {
  flag: string;
  name: string;
  population: string;
}
interface statisticsData {
  singleTotal: number;
  singleVerified: number;
  singleUnverified: number;
  singleAutoRejected: number;
  singlePending: number;
  singleRejected: number;
  preApprovedCount: number;
  rapidVisitorCount: number;
  gateEntryCount: number;
  preVerifiedCount: number;
}
